import React, { useState } from 'react'
import {
    Card,
    Image,
    Flag,
    List,
    Segment,
    Icon,
    Label,
} from 'semantic-ui-react'
import Tags from '../../../../Resources/Tags'
import countries from '../../../../../constants/countries.json'
import moment from 'moment'

const JobCard = ({ job }) => (
    <Card className="job-card" fluid>
        <Card.Content>
            <Image
                floated="right"
                size="mini"
                src={
                    job.project.type === 'Interview'
                        ? `${process.env.REACT_APP_AWS_S3_URL}/interview.svg`
                        : `${process.env.REACT_APP_AWS_S3_URL}/survey.svg`
                }
            />
            <Card.Header>{job.project.title}</Card.Header>
            <Card.Meta>{job.overall_status}</Card.Meta>
            <Card.Meta>
                {`Last updated: ${moment(job.updatedAt).format('MM/DD/YYYY')}`}
            </Card.Meta>
        </Card.Content>
    </Card>
)

const ExpertCard = ({ user }) => {
    const [expand, setExpand] = useState(false)
    return (
        <Card className="expert-card" fluid>
            <Card.Content>
                <Image
                    floated="left"
                    avatar
                    src={
                        user.expert.profile_picture || '/logos/fake_avatar.png'
                    }
                />
                <Card.Header className="expert-card-header">
                    {`${user.fullName} (${user.email})`}
                    <Flag
                        style={{ marginLeft: '5px' }}
                        name={countries[user.expert.country]}
                    />
                </Card.Header>
                <Card.Meta>{`${user.expert.title} | ${user.expert.organization.name}`}</Card.Meta>
                <Card.Description>
                    <List>
                        {user.membership.length > 0 && (
                            <List.Item>
                                <List.Header className="red">
                                    {`This account is also a Client account (${user.membership
                                        .map((m) => m.teamName)
                                        .join(', ')})`}
                                </List.Header>
                            </List.Item>
                        )}
                        <List.Item>
                            <List.Header>Expert Status: </List.Header>
                            <List.Description>
                                {user.expert.isBlocked ? (
                                    <Label color="black">Blocked</Label>
                                ) : (
                                    user.expert.status
                                )}
                            </List.Description>
                        </List.Item>
                        <List.Item>
                            <List.Header>Stripe Status: </List.Header>
                            {user.expert.stripeAccount.isConnected ? (
                                <List.Description>Connected</List.Description>
                            ) : (
                                <List.Description className="red">
                                    Not Connected
                                </List.Description>
                            )}
                        </List.Item>
                        <List.Item>
                            <List.Header>Bio Word Count: </List.Header>
                            <List.Description>
                                {user.expert.description?.length || 0}
                            </List.Description>
                        </List.Item>
                        <List.Item>
                            <List.Header
                                as="a"
                                onClick={() => setExpand(!expand)}
                            >
                                {`Engagements (${user.jobs.length})`}
                                <Icon
                                    name={`angle ${expand ? 'up' : 'down'}`}
                                />
                            </List.Header>
                            {expand && (
                                <Segment className="jobs">
                                    {user.jobs.map((job) => (
                                        <JobCard key={job.id} job={job} />
                                    ))}
                                </Segment>
                            )}
                        </List.Item>
                        <List.Item>
                            <List.Header>Tags</List.Header>
                            <Tags
                                tags={user.expert.functions.concat(
                                    user.expert.organization.type,
                                    user.expert.medical_specialties,
                                    user.expert.technology_tags
                                )}
                                internal_tags={[]}
                            />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        </Card>
    )
}
export default ExpertCard
